import React from 'react';

import { ViewNavItem } from '../../components/ViewNavItem';
import { VIEWS } from '../../constants';
import { useApp } from '../../store/AppContext';

/* Menu des membres (hors managers) : leurs feuilles d'heures, congés et affectations. */
export default function PersonalNav() {
  const { isManager, sidebarCollapsed } = useApp();
  if (isManager) return null;
  return (
    <>
      {!sidebarCollapsed && <div className="nav-section">Mon espace</div>}
      <ViewNavItem view={VIEWS.TIMESHEETS} icon="ti-clock-hour-4" label="Feuilles d'heures" />
      <ViewNavItem view={VIEWS.LEAVE} icon="ti-calendar-off" label="Congés" />
      <ViewNavItem view={VIEWS.TIMELINE} icon="ti-timeline" label="Affectations" />
    </>
  );
}
